import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_PATIENT_PHARMACIES' as const;
export { ExportStatus as Status };
